import { render, staticRenderFns } from "./ClassIntervalForm.vue?vue&type=template&id=340988e0&scoped=true&"
import script from "./ClassIntervalForm.vue?vue&type=script&lang=js&"
export * from "./ClassIntervalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340988e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
